import React from 'react';

export default function EmptyCart(){
    return(
        <div className='container mt-5'>
            <div className='col-10 mx-auto col-lg text-center text-title'>
                <h1> Your Cart Is Empty</h1>
            </div>
        </div>
    ) 
}